(function () {
  var APPLY_SELECTOR = '[data-oval-discount-apply]';
  var INPUT_SELECTOR = '#OvalDiscountCode';
  var MSG_SELECTOR = '.oval-discount__msg';

  // No auto-hide
  var OUT_ANIM_MS = 260; // should match your CSS timing (~.25s)

  // Update this if your cart drawer uses a different selector
  var CART_DRAWER_SELECTOR = 'cart-drawer, #CartDrawer, .cart-drawer, .Drawer--cart, #cart-drawer';

  function getContainerFrom(el) {
    return el && el.closest ? el.closest('.oval-discount') : null;
  }

  function ensureMsg(container) {
    if (!container) return null;
    var msg = container.querySelector(MSG_SELECTOR);
    if (!msg) return null;

    // IMPORTANT: don't use [hidden] if you want transitions
    msg.removeAttribute('hidden');

    return msg;
  }

  function hideMsg(msg) {
    if (!msg) return;

    if (msg.__ovalOutTimer) window.clearTimeout(msg.__ovalOutTimer);

    // animate out (reverse of animate in)
    msg.classList.remove('is-visible');

    // AFTER the slide/fade finishes, clean up
    msg.__ovalOutTimer = window.setTimeout(function () {
      msg.classList.remove('is-success', 'is-error');
      msg.textContent = '';
    }, OUT_ANIM_MS);
  }

  function showMsg(container, text, ok) {
    var msg = ensureMsg(container);
    if (!msg) return;

    if (msg.__ovalOutTimer) window.clearTimeout(msg.__ovalOutTimer);

    msg.textContent = text || '';
    msg.classList.remove('is-success', 'is-error');
    msg.classList.add(ok ? 'is-success' : 'is-error');

    // restart animation cleanly
    msg.classList.remove('is-visible');
    msg.offsetHeight; // force reflow so transition restarts

    requestAnimationFrame(function () {
      msg.classList.add('is-visible');
    });

    // NOTE: no timeout here — stays until cart close or page reload
  }

  function clearAllMsgsInCart() {
    var drawers = document.querySelectorAll(CART_DRAWER_SELECTOR);
    if (!drawers.length) return;

    drawers.forEach(function (drawer) {
      var msgs = drawer.querySelectorAll(MSG_SELECTOR);
      msgs.forEach(function (msg) {
        hideMsg(msg);
      });
    });
  }

  function isDrawerOpen(drawer) {
    if (!drawer) return false;

    // Common patterns across themes
    if (drawer.tagName && drawer.tagName.toLowerCase() === 'cart-drawer') {
      if (drawer.hasAttribute('open')) return true;
    }

    var ariaHidden = drawer.getAttribute && drawer.getAttribute('aria-hidden');
    if (ariaHidden === 'false') return true;
    if (ariaHidden === 'true') return false;

    var cls = (drawer.className || '').toString();
    if (cls.indexOf('is-open') > -1) return true;
    if (cls.indexOf('open') > -1) return true;

    return false;
  }

  function watchCartClose() {
    var drawer = document.querySelector(CART_DRAWER_SELECTOR);
    if (!drawer) return false;

    var lastOpen = isDrawerOpen(drawer);

    var obs = new MutationObserver(function () {
      var nowOpen = isDrawerOpen(drawer);
      if (lastOpen && !nowOpen) {
        clearAllMsgsInCart();
      }
      lastOpen = nowOpen;
    });

    obs.observe(drawer, {
      attributes: true,
      attributeFilter: ['open', 'aria-hidden', 'class', 'style']
    });

    // Also clear on Escape (many drawers close via Escape)
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        clearAllMsgsInCart();
      }
    });

    return true;
  }

  function applyCodeSilently(code) {
    return new Promise(function (resolve) {
      var iframe = window.__ovalDiscountIframe;

      if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.width = 0;
        iframe.height = 0;
        iframe.setAttribute('aria-hidden', 'true');
        document.body.appendChild(iframe);
        window.__ovalDiscountIframe = iframe;
      }

      iframe.onload = function () { resolve(); };
      iframe.src = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    });
  }

  function handleApply(btn) {
    var container = getContainerFrom(btn) || document.querySelector('.oval-discount');
    if (!container) return;

    var input = container.querySelector(INPUT_SELECTOR);
    if (!input) return;

    var code = (input.value || '').trim();
    if (!code) {
      showMsg(container, 'Please enter a promo code.', false);
      return;
    }

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    applyCodeSilently(code)
      .then(function () {
        showMsg(container, 'Promo code added. Discounts are applied at checkout if eligible.', true);
        input.value = '';
      })
      .catch(function () {
        showMsg(container, 'Unable to apply promo code. Please try again.', false);
      })
      .finally(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(APPLY_SELECTOR) : null;
    if (!btn) return;
    e.preventDefault();
    handleApply(btn);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target && e.target.closest ? e.target.closest(INPUT_SELECTOR) : null;
    if (!input) return;

    var container = getContainerFrom(input);
    if (!container) return;

    var btn = container.querySelector(APPLY_SELECTOR);
    if (!btn) return;

    e.preventDefault();
    handleApply(btn);
  });

  // Watch cart open/close; if your theme mounts the drawer later, retry a bit
  if (!watchCartClose()) {
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (watchCartClose() || tries > 30) clearInterval(iv);
    }, 250);
  }
})();